import type { RestRecord } from '@libs/data-access/entities'
import type { DoubleStringTuple } from '@spa/features/Scheduling'
import type { Moment } from 'moment'

export const getDefaultTimeRange = ({
  defaultStart,
  defaultEnd,
  rest
}: {
  defaultStart: Moment
  defaultEnd: Moment
  rest?: RestRecord
}) => {
  const start = defaultStart.format('HH:mm')
  const end = defaultEnd.format('HH:mm')
  // Prevent initializing with invalid form values
  const areEquals = start === end

  return [
    start,
    rest?.id && !areEquals
      ? defaultEnd.format('HH:mm')
      : defaultStart.clone().add(4, 'hours').format('HH:mm')
    // Here we add 4 hours to make that the time_range to be the same as the shiftForm. It's also the most usual rest time_range for our users
  ] as DoubleStringTuple
}
